export default __webpack_public_path__ + "static/media/next-disabled.7de6e2b0.svg";